var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 13.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Banner notification",
    clipPath: "url(#clip0_3_366264)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-366 -541)",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg main contant",
    filter: "url(#filter0_d_3_366264)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -225,
    y: -300,
    width: 1275,
    height: 1006,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -224.5,
    y: -299.5,
    width: 1274,
    height: 1005,
    rx: 3.5,
    stroke: "#EAEEEF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 4",
    x: -193,
    y: -8,
    width: 1210,
    height: 32,
    rx: 4,
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 13 Copy 2",
    clipPath: "url(#clip1_3_366264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter",
    clipPath: "url(#clip2_3_366264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons / Sorting table Copy 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon / Sorting table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "up-arrow",
    className: "table-sort-arrow",
    d: "M11.06 7.5L8 4.40958L4.94 7.5L4 6.54858L8 2.5L12 6.54858L11.06 7.5Z",
    fill: "#A4A8B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "down-arrow",
    className: "table-sort-arrow",
    d: "M4.94 9L8 12.0904L11.06 9L12 9.95142L8 14L4 9.95142L4.94 9Z",
    fill: "#A4A8B1"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_366264",
    x: -229,
    y: -302,
    width: 1283,
    height: 1014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_366264"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_366264",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_366264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-366 -541)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_366264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 16,
    fill: "white",
    transform: "translate(-65)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3_366264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 16,
    fill: "white",
    transform: "translate(-18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/Sorting.71bb2f510cc22a9922a78c44b7e9de6c.svg";
export { ForwardRef as ReactComponent };